/** @jsx jsx **/
import { jsx } from "@emotion/react";
import { useContext } from "react";

import { DetermineMobileContext } from "@modules";

import * as styles from "./servicecenter.style";

export default function ServiceCenter() {
  const isMobile = useContext(DetermineMobileContext);

  return (
    <div css={styles.rowCompanyName}>
      <p css={styles.title}>고객지원실 운영안내</p>
      <p css={styles.sub}>
        <span css={[styles.subDark, styles.line]}>연중무휴 09:00-18:00 (점심시간 12:00-13:00)</span>
        {!isMobile && <br />}
        <span css={[styles.subDark, styles.line]}>주말/공휴일 포함, 한국시간 기준</span>
        {!isMobile && <br />}
        <span css={[styles.subDark, styles.line]}>※ 항공권 환불/변경은 평일 09:00-17:00 접수 가능</span>
        {!isMobile && <br />}
        <span css={styles.subDark}>유선상담 1670-8208</span>
      </p>
    </div>
  );
}
